import React from "react"
import { Container, } from "reactstrap"

import FinancialReport from "./FinancialReport"
import ResolvedTransferTransactions from "./ResolvedTransferTransactions ";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import RevenueCard from "./RevenueCard";

const newPage = () => {
  // meta title
  document.title = "المستحقات| DBsaloni Admin & Dashboard "

  return (
    <>
      <div className="page-content">
        <Container fluid={false}>
          <Breadcrumbs
            title=" المستحقات"
            breadcrumbItem="ادارة المستحقات"
          />
          {/* <RevenueCard /> */}
           <FinancialReport />
          {/* Financial Report Section */}
          <ResolvedTransferTransactions />
     

        </Container>
      </div>
    </>
  )
}

export default newPage